export default __webpack_public_path__ + "static/media/wreckingball-shields.1f0e56cc.mp3";